import { useLocalStorage } from "@jugl-web/utils/hooks/useStorage";
import { SKIP_FUTURE_ALERTS_CONFIG_KEY } from "@jugl-web/utils/storage";
import { useCallback } from "react";

interface SkipFutureAlertsConfig {
  [alertId: string]: boolean;
}

export const useSkipFutureAlerts = () => {
  const [config, setConfig] = useLocalStorage<SkipFutureAlertsConfig>(
    SKIP_FUTURE_ALERTS_CONFIG_KEY,
    {}
  );

  const areFutureAlertsSkipped = useCallback(
    (alertId: string) => config[alertId] ?? false,
    [config]
  );

  const onSkipFutureAlertsChange = useCallback(
    (alertId: string, shouldSkip: boolean) => {
      setConfig((previousConfig) => ({
        ...previousConfig,
        [alertId]: shouldSkip,
      }));
    },
    [setConfig]
  );

  return {
    areFutureAlertsSkipped,
    onSkipFutureAlertsChange,
  };
};
